module.exports = __webpack_public_path__ + "media/img/vca/winner3-36503d1c96e462a5c56c4a021c8499a0.png";